import { DependencyData, TimeExpenseEntry } from "./types-time-entry";



export interface Timer {
    title?: string,
    handlePlay?: (obj: Obj) => void;
    handlePause?: (obj: Obj) => void;
    matterId?: string | null;
    userId?: null;
    entryDate?: null | string;
    durationInSeconds?: null | number;
    tHoursDurationQuantity?: null;
    billingCost?: null;
    billingRate?: null;
    description?: null;
    isBillable?: null;
    activityType?: null;
    isVisibleToBill?: null;
    taxId?: null;
    isTaxable?: null;
    appliedTaxOnInvoice?: null;
    privateNote?: null;
    tagResourceId?: null;
    expenseCategoryId?: null;
    activityCategoryUtbmsCodeId?: null;
    utbmsType?: null;
    utbmsTaskCodeId?: null;
    utbmsExpenseCodeId?: null;
    isTimerRunning?: boolean | null;
    writtenOff?: null;
    resourceId?: string;
    resourceType?: ResourceTypeEnum;
    billingStatus?: 0 | 1 | 2 | null | boolean;
    invoiceNumber?: string;
    matter?: {
        id: string,
        title: string
    } | null;
    user?: null;
    id?: string;
    parent?: null;
    isActive?: boolean;
    metadata?: null
    isDeleted?: boolean | null;
    deletedBy?: string | null;
    deletedOn?: string | string;
    updatedBy?: string | null;
    updatedOn?: string | null;
    createdBy?: string | null;
    createdOn?: string | null;
}

export interface Obj {
    durationInSeconds?: string | number;
    id?: string;
    position?: string;
}

export interface TimerInput extends Timer {
}
export interface InitialState {
    timers: TimerResponse;
    timer: Timer;
    currentTimer:Timer
    dependencyData: DependencyData
    timeExpenseEntry: TimeExpenseEntry
    steps:{
        steps:Array<Step>
        position:PositionEnum
    }
    communication:Communication
    sendMailLoading:boolean
    createEmailLogLoading:boolean
    documents:Document[]
    matters?: Matter[]
}
export interface Step{
    title?:string
    subTitle?:string
    stepId?:PositionEnum
    data?:any
    component?:(callBack:()=>void)=>React.ReactNode
}
export type getDependencyDataPayload = {
    payload: DependencyData
}

export interface Document {
    title?:                   string;
    description?:             null;
    documentCategoryId?:      string;
    folderId?:                string;
    receivedDate?:            Date;
    isArchived?:              boolean;
    archivedReason?:          null;
    archivedAt?:              Date;
    isHidden?:                boolean;
    isLocked?:                boolean;
    isFolder?:                boolean;
    folderType?:              number;
    overAllCommentCount?:     null;
    versions?:                null;
    docType?:                 number;
    fieldVariableMask?:       null;
    documentCategoryDetails?: DocumentCategoryDetails;
    matterDetails?:           null;
    eSignatureStatus?:        null;
    eSignatureId?:            null;
    eSignatureInitiationOn?:  null;
    eSignatureData?:          null;
    totalHours?:              null;
    createdByName?:           string;
    updatedByName?:           null;
    sharedByName?:            null;
    sharedById?:              null;
    accessLevel?:             number;
    tags?:                    null;
    aiAction?:                number;
    associatedResources?:     any[];
    previousId?:              null;
    nextId?:                  null;
    id?:                      string;
    parent?:                  string;
    isActive?:                boolean;
    metadata?:                null;
    isDeleted?:               null;
    deletedBy?:               null;
    deletedOn?:               Date;
    updatedBy?:               string;
    updatedOn?:               Date;
    createdBy?:               string;
    createdOn?:               Date;
}

export interface DocumentCategoryDetails {
    id?:    string;
    title?: string;
}

export interface Matter {
    matterTitle?: string
    isSplitTime?: boolean
    id?: string
}

export interface TimerResponse {
    hasMore: boolean;
    data: Timer[] | null | Array<Timer>;
    rowCount: number;

    append?: boolean;

}

export enum ActivityTypeEnum {
    Unspecified = -1,
    Time = 1,
    Expense = 2,
}
export interface User {
    firstName?: string
    lastName?: string
    email?: string
    id?: string
    userId?: string
    isCoCounsel?: boolean
}
export interface InvoiceNumber {
    id?: string
    number?: string
}
export enum ResourceTypeEnum {
    Unspecified = 0,
    Tasks = 1,
    Events = 2,
    Communication = 3,
    Document = 4,
    Gmail=5,
    OutLook=6
}
export enum TimeEntryInvoiceStatusEnum {
    Unbilled = 0,
    Draft = 1,
    Billed = 2,
}
export interface TimerFilter extends Sortable {
   resourceId:string
}

export type getDataPayload = {
    payload: TimerResponse;
};
export type getRecordPayload = {
    payload: Timer;
};

export enum OrderBy {
    ASC = 'asc',
    DESC = 'desc'
}


export enum TimerStatus {
    draft = 0,
    billed = 1,
}

export enum TimerStauses {
    start = 0,
    pause = 1,
    resume = 2
}

export type Sortable = {
    sortBy?: string;
    orderBy?: SortDirection;
    sortDirection?: SortDirection | SortDirectionEnum;
};

export declare enum SortDirectionEnum {
    Asc = 0,
    Desc = 1
}
export type SortDirection = 'asc' | 'desc' | false;
/**/
export interface CommunicationLogInput{
        id?:string
        matterId: string,
        messageFrom: Array<string>,
        messageTo: Array<string>,
        subject: string,
        messageBody: string,
        dateOn: string,
        resourceId: string,
        resourceType: CommunicationResourceTypeEnum //For EmailAddOn
        matter?:Matter
}
export interface UploadDocumentInput{
    fileName:string
    communicationId:string
    docType:number
    fileBytes?:string
    addOnType?:1|2 // 1=Gmail | 2=Outlook
    fileBase64?:string
}
export enum CommunicationResourceTypeEnum{
    EmailAddOn=1
}

export enum PositionEnum{
    Initial=0,
    TimeEntryCreate=1,
    CommunicationCreate=2,
    TimeEntryUpdate=3,
    SendMail=4
}

export interface Communication {
    communicationType?: number
    matterId?: string
    messageFrom?: string[]
    messageTo?: string[]
    subject?: string
    messageBody?: string
    dateOn?: string
    callDuration?: number
    fieldVariableMask?: string
    communicationDocuments?: null
    tags?: any
    communicationFrom?: CommunicationFrom[] | null
    communicationTo?: CommunicationTo[] | null
    id?: string
    parent?: string
    isActive?: boolean
    metadata?: string
    isDeleted?: boolean
    deletedBy?: string
    deletedOn?: string
    updatedBy?: string
    updatedOn?: string
    createdBy?: string
    createdOn?: string
    matterTitle?: null
    totalHours?: number
}

export interface CommunicationFrom {
    contactType?: number
    companyName?: string
    companyId?: null
    contactPrefix?: null
    initial?: null
    firstName?: string
    middleName?: null
    lastName?: string
    employee?: null
    primaryEmail?: null
    email?: Email[]
    phone?: null
    website?: null
    address?: null
    timezone?: null
    customFieldsValues?: null
    oldCustomFieldSetAssociation?: null
    profileImageThumbImage?: null
    profileImageLargeImage?: null
    fieldVariableMask?: null
    customFieldSetAssociation?: null
    primaryPhone?: null
    isClient?: boolean
    title?: null
    userId?: null
    tags?: null
    id?: string
    parent?: null
    isActive?: boolean
    metadata?: null
    isDeleted?: null
    deletedBy?: null
    deletedOn?: null
    updatedBy?: null
    updatedOn?: null
    createdBy?: null
    createdOn?: string
    matterTitle?: null
}

export interface Email {
    email?: string
    emailType?: string
    isPrimary?: boolean
}

export interface CommunicationTo {
    contactType?: number
    companyName?: string
    companyId?: null
    contactPrefix?: null
    initial?: null
    firstName?: string
    middleName?: null
    lastName?: string
    employee?: null
    primaryEmail?: null
    email?: string
    phone?: null
    website?: null
    address?: null
    timezone?: null
    customFieldsValues?: null
    oldCustomFieldSetAssociation?: null
    profileImageThumbImage?: null
    profileImageLargeImage?: null
    fieldVariableMask?: null
    customFieldSetAssociation?: null
    primaryPhone?: null
    isClient?: boolean
    title?: null
    userId?: null
    tags?: null
    id?: string
    parent?: null
    isActive?: boolean
    metadata?: null
    isDeleted?: null
    deletedBy?: null
    deletedOn?: null
    updatedBy?: null
    updatedOn?: null
    createdBy?: null
    createdOn?: string
    matterTitle?: null
}

export type CommunicationFilter = Array<string> 